import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SiteCtx = createContext({ site: null, rates: null, vehicles: [], reloadVehicles: () => {} });

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const [rates, setRates] = useState(null);
  const [vehicles, setVehicles] = useState([]);

  const loadVehicles = async () => {
    try { const r = await api.get("/vehicles"); setVehicles(r.data); } catch (e) { console.error(e); }
  };

  useEffect(() => {
    (async () => {
      try {
        const [s, r] = await Promise.all([api.get("/site"), api.get("/rates")]);
        setSite(s.data); setRates(r.data);
      } catch (e) { console.error(e); }
      loadVehicles();
    })();
  }, []);

  return (
    <SiteCtx.Provider value={{ site, rates, vehicles, reloadVehicles: loadVehicles }}>
      {children}
    </SiteCtx.Provider>
  );
}

export const useSite = () => useContext(SiteCtx);
